import { render, staticRenderFns } from "./ViewSelector.vue?vue&type=template&id=0d63676e&scoped=true&"
import script from "./ViewSelector.vue?vue&type=script&lang=js&"
export * from "./ViewSelector.vue?vue&type=script&lang=js&"
import style0 from "./ViewSelector.vue?vue&type=style&index=0&id=0d63676e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d63676e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
